import m from "../../geodata/es2015/icelandLow";
window.am4geodata_icelandLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/icelandLow.js
// module id = null
// module chunks = 